<template>
  <section :class="
    `offices-map` + (officeInfoVisible ? ' offices-map--info-visible' : '')
  ">
    <div class="offices-map__container">
      <div class="offices-map__map">
        <GmapMap :center="mapCenter" :zoom="mapZoom" @zoom_changed="zoomChanged($event)" map-type-id="terrain"
          style="width: 100%;" :options="{
            styles: mapStyle,
            mapTypeControl: false,
            streetViewControl: false
          }">
          <GmapCluster :label="{ color: 'white' }" :zoom-on-click="true" :styles="[
            {
              url: '/app/themes/redbeemedia/images/map-cluster.svg',
              width: 45,
              height: 46,
              textSize: 14,
              textColor: 'white'
            }
          ]">
            <GmapMarker :position="getOfficeCoordinates(office)" :key="index" v-for="(office, index) in data.offices"
              :icon="getIconMarker(office)" @click="zoomToOffice(office)"
              :label="{ text: office.office_name, color: 'black' }" />

            />
          </GmapCluster>
        </GmapMap>
      </div>
      <div class="offices-map__info">
        <div class="offices-map__info__inner typography">
          <a @click.prevent="
  activeOffice = null;
officeInfoVisible = false;
isFormLoading = true;
          " v-if="activeOffice !== null" class="offices-map__info__close"
            aria-label="Close office information window"></a>
          <div v-if="activeOffice">
            <p class="offices-map__info__country">
              {{ activeOffice.country }}
            </p>
            <h3 class="offices-map__info__office-name">
              {{ activeOffice.office_name }}
            </h3>
            <div class="offices-map__info__detail">
              <div class="offices-map__info__detail__address">
                <p v-html="activeOffice.address"></p>
                <p v-if="activeOffice">
                  <a :href="activeOffice.link.url" :title="activeOffice.link.title" :target="activeOffice.link.target">
                    {{ activeOffice.link.title }}
                  </a>
                </p>
                <div class="offices-map__info__detail__contact">

                  <p class="offices-map__info__detail__contact__phone">
                    <a :href="`tel:` + activeOffice.phone_number" title="Telephone us">{{ activeOffice.phone_number
                    }}</a>
                  </p>
                  <p class="offices-map__info__detail__contact__email">
                    <a :href="`mailto:` + activeOffice.email" title="Email us">{{
                        activeOffice.email
                    }}</a>
                  </p>
                </div>
              </div>

              <div class="offices-map__info__banners">
                <a :href="banner.link.url" :target="banner.link.target" class="offices-map__info__banners__banner"
                  v-for="(banner, index) in activeOffice.banners" :key="'banner' + index"
                  :style="getBannerStyle(banner)">
                  <inline-svg v-if="!banner.image" src="/app/themes/redbeemedia/images/arrow-right-white.svg"
                    class="offices-map__info__banners__banner__arrow"></inline-svg>
                  <div class="offices-map__info__banners__banner__overlay"></div>
                  <span class="offices-map__info__banners__banner__inner" v-html="banner.link.title"></span>
                </a>
              </div>

            </div>
            <div class="offices-map__info__vacancies" v-if="data.should_display_vacancies_text"
              v-html="data.vacancies_text"></div>
            <div class="offices-map__info__form-toggles" v-if="activeOffice.remote_captioning_ninja_form">
              <a href="#" @click.prevent="displayForm('contact')"
                :class="formToDisplay === 'contact' ? 'active' : ''">Contact</a>
              <a href="#" @click.prevent="displayForm('remote_captioning')"
                :class="formToDisplay === 'remote_captioning' ? 'active' : ''">
                <span v-if="activeOffice.remote_captioning_form_label">{{
                    activeOffice.remote_captioning_form_label
                }}</span>
                <span v-else>Remote Captioning</span>
              </a>
            </div>
            <div class="offices-map__info__form" v-if="getContactFormUrl">
              <div v-if="isFormLoading">Loading form...</div>
              <iframe @load="setFormLoaded()" id="form-iframe" :src="getContactFormUrl" frameborder="0"
                :class="isFormLoading ? 'hidden' : ''"></iframe>
            </div>
          </div>

          <div v-else class="offices-map__info__regions-panel">
            <h3>{{ data.office_listing_title }}</h3>
            <p>{{ data.office_listing_copy }}</p>

            <v-collapse-group :onlyOneActive="true" class="offices-map__info__regions">
              <v-collapse-wrapper v-for="(region, index) in officesByRegion" :key="`region` + index"
                :class="regionClass(region)">
                <h5 @click="selectRegion(region)" v-collapse-toggle>
                  {{ region.title }}
                </h5>
                <div class="v-collapse-content">
                  <div class="v-collapse-content-inner">
                    <div v-for="(country, countryIndex) in region.countries" :key="`country` + countryIndex"
                      class="offices-map__info__regions__country">
                      <h5>{{ country.title }}</h5>
                      <div v-for="(office, officeIndex) in country.offices" :key="`office` + officeIndex">
                        <p @click="zoomToOffice(office)" class="offices-map__info__regions__office">
                          <span class="offices-map__info__regions__office__city">{{ office.city }}</span>
                          {{ office.office_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </v-collapse-wrapper>
            </v-collapse-group>
          </div>
        </div>

        <div class="offices-map__media-relations" v-if="(!activeOffice && data.activate_media_relations_banner)">
          <div class="offices-map__media-relations__inner" @click="showMediaRelationsForm()">
            <div class="white-background"></div>
            <div class="offices-map__info__banner__inner__arrow">
              <inline-svg src="/app/themes/redbeemedia/images/arrow-right-white.svg"
                class="offices-map__info__banner__inner__arrow__svg"></inline-svg>
            </div>
            <div class="offices-map__info__banner__inner__text">
              <h3 class="offices-map__info__banner__inner__text__top">{{ data.media_relations_top_text }}</h3>
              <p class="offices-map__info__banner__inner__text__bottom">{{ data.media_relations_bottom_text }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import slugify from "slugify";
import { isMobile } from "mobile-device-detect";


const mediaRelationsOffice = {
  office_name: "Media Relations",
  // phone_number: "055555555555",
  // email: "test@test.com",
  // city: "Media Relations",
  // address: "Media Relations",
  link: "google.com",
  // country: "Media Relations",
  // region: "Media Relations",
  latitude: 0,
  longitude: 0,
  banners: []
};





export default {
  name: "OfficeLocationsMap",
  data: function () {
    return {
      data: window.officeLocationsMap,
      expandedRegion: null,
      selectedOffice: window.selectedOffice,
      selectedForm: window.selectedForm,
      activeOffice: null,
      mapCenter: { lat: 0, lng: 0 },
      mapZoom: this.getInitialZoom(),
      officeInfoVisible: false,
      formToDisplay: "contact",
      isFormLoading: true,
      initialPageTitle: null,
      initialPageUrl: window.initialPageUrl,
      isZoomed: false,
      officesByRegion: []
    };
  },
  mounted() {
    this.initialPageTitle = document.title;
    // If we have a selected office, load that office
    const foundOffice = this.data.offices.filter(
      office =>
        this.slugify(office.office_name.toLowerCase()) === this.selectedOffice
    );
    if (foundOffice && foundOffice.length) {
      this.zoomToOffice(foundOffice[0]);
    }
    this.loadOfficesByRegion();
    if (this.selectedForm === "booking") {
      this.formToDisplay = "remote_captioning";
    }
  },
  methods: {
    /**
     * Get the style for a banner
     */

    // add mediaRelationsOffice to the list of offices
    getBannerStyle(banner) {
      if (banner.image) {
        return {
          backgroundImage: "url(" + banner.image.sizes['post-thumbnail'] + ")"
        }
      } else {
        return null
      }
    },
    displayForm(formName) {
      this.isFormLoading = true;

      let urlPath =
        this.initialPageUrl + this.slugify(this.activeOffice.office_name) + "/";
      if (formName === "remote_captioning") {
        urlPath += "form/booking/";
      }
      this.formToDisplay = formName;
      window.history.pushState({}, "", urlPath);
    },
    showMediaRelationsForm() {
      this.activeOffice = mediaRelationsOffice;
      this.displayForm("Media Relations Contact Form");
      this.officeInfoVisible = true;
    },
    selectRegion(region) {
      // Reset the map and deselect the region if this is a toggle
      if (this.expandedRegion && region.title === this.expandedRegion.title) {
        this.expandedRegion = null;
        this.resetMap();
      } else {
        // Zoom to the specified region
        this.zoomToLocation(
          region.data.centre_point.lat,
          region.data.centre_point.lng,
          region.data.zoom_level,
          region.title
        );
        this.expandedRegion = region;
      }
    },
    /**
     * This method loads data from the data.offices array into the officesByRegion array
     */
    loadOfficesByRegion() {
      const regions = [...new Set(this.data.offices.map(item => item.region))];

      let officesByRegion = [];
      // Loop around the regions and get the offices...
      regions.forEach(region => {
        // Get the unique countries that are in this region
        let regionOffices = this.data.offices.filter(office => {
          return office.region === region;
        });
        // Get unique countries
        const regionCountryName = [
          ...new Set(regionOffices.map(item => item.country))
        ];

        const regionCountries = [];

        // Now get offices in each country
        regionCountryName.forEach(country => {
          let countryOffices = this.data.offices.filter(office => {
            return office.country === country;
          });
          regionOffices.push(countryOffices);
          regionCountries.push({
            title: country,
            offices: countryOffices
          });
        });

        let regionData = this.data.region_data.filter(regionItem => {
          return regionItem.region === region;
        });

        officesByRegion.push({
          title: region,
          data: regionData[0],
          countries: regionCountries
        });
      });

      this.officesByRegion = officesByRegion;
    },
    /**
     * Set the mapZoom when the zoom is changed
     * @param event
     */
    zoomChanged(event) {
      this.mapZoom = event;
    },
    /**
     * Set the form to loaded
     */
    setFormLoaded() {
      this.isFormLoading = false;
    },
    /**
     * Convert a string to a slug
     * @param string
     * @returns {string}
     */
    slugify(string) {
      return slugify(string.toLowerCase());
    },
    /**
     * Return the coordinates for a specific office
     * @param office
     * @returns {{lng: number, lat: number}}
     */
    getOfficeCoordinates(office) {
      return {
        lat: parseFloat(office.map_location.lat),
        lng: parseFloat(office.map_location.lng)
      };
    },
    /**
     * Zoom the map to a specific office
     * @param office
     */
    zoomToOffice(office) {
      this.formToDisplay = "contact";
      this.mapZoom = 12;
      this.officeInfoVisible = true;
      this.activeOffice = office;
      // Set the history state
      let pageTitle = office.office_name + " - " + this.initialPageTitle;
      let urlPath =
        this.initialPageUrl + this.slugify(office.office_name) + "/";
      if (this.selectedForm === "booking") {
        urlPath += "form/booking/";
      }
      window.history.pushState({ pageTitle: pageTitle }, "", urlPath);
      document.title = pageTitle;

      setTimeout(() => {
        this.mapCenter = this.getOfficeCoordinates(office);
      }, 300);
    },
    /**
     * Zoom to a specific location on the map
     *
     */
    zoomToLocation(lat, lng, zoom, title) {
      this.mapZoom = parseFloat(zoom);
      this.mapCenter = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
      // Set the history state
      let pageTitle = title + " - " + this.initialPageTitle;
      let urlPath = this.initialPageUrl + this.slugify(title) + "/";
      window.history.pushState({ pageTitle: pageTitle }, "", urlPath);
      document.title = pageTitle;
    },
    /**
     * Reset the map to its inital state
     */
    resetMap() {
      this.officeInfoVisible = false;
      this.activeOffice = null;
      this.isFormLoading = true;
      this.mapZoom = this.getInitialZoom();
      this.mapCenter = { lat: 15, lng: 0 };

      // Set the history state
      window.history.pushState(
        { pageTitle: this.initialPageTitle },
        "",
        this.initialPageUrl
      );
      document.title = this.initialPageTitle;
    },
    /**
     * Get the marker for a particular office
     * @param office
     * @returns {{scaledSize: {width: number, height: number}, labelOrigin: {x: number, y: number}, url: string}}
     */
    getIconMarker(office) {
      let markerUrl = "";
      if (
        this.activeOffice !== null &&
        office.office_name === this.activeOffice.office_name
      ) {
        markerUrl = "/app/themes/redbeemedia/images/map-marker-active.svg";
      } else {
        markerUrl = "/app/themes/redbeemedia/images/map-marker.svg";
      }

      let marker = {
        url: markerUrl,
        scaledSize: { width: 30, height: 36 },
        size: { width: 30, height: 36 },
        labelOrigin: { x: 25, y: -8 }
      };
      return marker;
    },
    /**
     * Get the inital zoom level
     * @returns {number}
     */
    getInitialZoom() {
      return isMobile ? 1 : 2;
    },
    regionClass(region) {
      if (
        this.expandedRegion !== null &&
        region.title == this.expandedRegion.title
      ) {
        return "active";
      } else {
        return "";
      }
    }
  },
  computed: {
    /**
     * Get the contact form URL for a specified office
     * @returns {string|null}
     */
    getContactFormUrl() {
      let formId;
      let officeName;
      if (this.activeOffice) {
        if (
          this.formToDisplay === "remote_captioning" &&
          this.activeOffice.remote_captioning_ninja_form
        ) {
          formId = this.activeOffice.remote_captioning_ninja_form.id;
          officeName = this.activeOffice.office_name
        } else if (
          this.formToDisplay === "contact" &&
          this.activeOffice.contact_ninja_form
        ) {
          formId = this.activeOffice.contact_ninja_form.id;
          officeName = this.activeOffice.office_name
        }
      }

      if (formId) {
        return "/ninja-forms-contact-forms/?formid=" + formId + '&office_name=' + officeName;
      } else if (this.formToDisplay === "Media Relations Contact Form") {
        return "/ninja-forms-contact-forms/?formid=" + this.data.media_relations_contact_form.id;
      } else {
        return null;
      }

    },
    /**
     * The map theme
     * @returns {*[]}
     */
    mapStyle() {
      return [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            {
              saturation: 36
            },
            {
              color: "#333333"
            },
            {
              lightness: 40
            }
          ]
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            {
              visibility: "on"
            },
            {
              color: "#ffffff"
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#fefefe"
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#fefefe"
            },
            {
              lightness: 17
            },
            {
              weight: 1.2
            }
          ]
        },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#DC281E"
            }
          ]
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5"
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5"
            },
            {
              lightness: 21
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#dedede"
            },
            {
              lightness: 21
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff"
            },
            {
              lightness: 17
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#ffffff"
            },
            {
              lightness: 29
            },
            {
              weight: 0.2
            }
          ]
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff"
            },
            {
              lightness: 18
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff"
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#f2f2f2"
            },
            {
              lightness: 19
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#e9e9e9"
            },
            {
              lightness: 17
            }
          ]
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.offices-map {
  &--info-visible {
    .offices-map__map {
      flex-basis: calc(100vw - 920px);
    }
  }

  &__container {
    overflow: hidden;
    display: flex;

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
  }

  &__map {
    transition: flex-basis 0.3s ease-in-out;
    flex: 0 0 100vw;
    flex-basis: calc(100vw - 420px);

    @media screen and (max-width: 767px) {
      order: 2;
    }

    .vue-map-container {
      height: 686px;

      @media screen and (max-width: 767px) {
        height: 500px;
      }

      @media screen and (max-width: 320px) {
        height: 400px;
      }
    }
  }

  &__info {
    flex: 0 0 920px;

    @media screen and (max-width: 767px) {
      order: 1;
      flex-basis: 100vw;
      width: 100vw;
      z-index: 2;
      background-color: white;
    }

    &__regions-panel {
      width: 352px;
      padding-top: 21px;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &__regions {
      margin: 32px 0;
      padding: 0;

      @media screen and (max-width: 767px) {
        margin: 17px 0 0;
      }

      .vc-collapse>h5 {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:after {
          background: {
            image: url("/app/themes/redbeemedia/images/chevron-red-right.svg");
            position: center;
            repeat: no-repeat;
          }

          transition: transform 0.3s ease-in-out;
          transform: rotate(270deg);
          content: "";
          display: block;
          width: 24px;
          height: 24px;
        }
      }

      .vc-collapse {
        border: 1px solid #dcdcdc;
        border-bottom: 0;

        &.active {
          background-color: #f5f5f5;

          h5 {
            &:after {
              transform: rotate(90deg);
            }
          }

          .v-collapse-content {
            max-height: 800px;
          }
        }

        &:last-child {
          border-bottom: 1px solid #dcdcdc;
        }
      }

      .v-collapse {
        &-toggler {
          padding: 12px;
          cursor: pointer;
        }

        &-content-end {}

        &-content-inner {
          padding: 0 12px;
        }
      }

      &__country {
        padding: 12px 0;
      }

      &__office {
        cursor: pointer;

        &__city {
          text-transform: uppercase;
          font-weight: 600;
          color: #dc281e;
        }
      }
    }

    &__vacancies {
      padding: 16px 24px;
      border: 1px solid #dcdcdc;
      margin-bottom: 24px;

      p {
        font-weight: bold;
        color: #646464;
        margin: 0;
      }
    }

    &__close {
      position: absolute;
      top: 24px;
      right: 0;
      width: 38px;
      height: 38px;
      background-color: #dc281e;
      border: 1px solid #dc281e;
      display: flex;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;

      @media screen and (max-width: 767px) {
        top: 15px;
        right: 15px;
      }

      &:after {
        content: "";
        display: block;
        width: 9px;
        height: 9px;

        background: {
          image: url("/app/themes/redbeemedia/images/icon-close-white.svg");
          position: center;
          repeat: no-repeat;
          size: cover;
        }
      }

      &:hover,
      &:focus {
        background-color: transparent;

        &:after {
          background: {
            image: url("/app/themes/redbeemedia/images/icon-close-red.svg");
          }
        }
      }
    }

    &__inner {
      position: relative;
      width: 760px;
      padding: 32px 0 32px 24px;

      @media screen and (max-width: 767px) {
        width: 100vw;
        padding: 32px 15px;
      }
    }

    &__country {
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 4px;
      color: #a0a0a0;
      font-weight: bold;
    }

    &__office-name {
      margin-bottom: 8px;
    }

    &__detail {
      display: flex;
      padding-bottom: 32px;

      @media screen and (max-width: 767px) {
        display: block;
        padding-bottom: 22px;
      }

      &__address {
        width: 287px;
        padding-right: 50px;

        @media screen and (max-width: 767px) {
          width: 100vw;
          padding-right: 0;
        }
      }

      &__contact {
        &__phone {
          a {
            font-size: 14px;
            font-weight: bold;
            color: #646464;
          }
        }

        &__email {
          a {
            font-size: 14px;
            font-weight: 600;
            color: #dc281e;
          }
        }
      }
    }

    &__banners {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      width: 100%;

      @media screen and (max-width: 767px) {
        display: block;
      }

      &__banner {
        height: 118px;
        flex-basis: 209px;
        display: flex;
        align-items: flex-end;
        padding: 18px 16px;
        background: linear-gradient(63deg, #DC281E 0%, #DC281E 70%, #F65F91 100%);
        position: relative;
        border: 1px solid transparent;
        transition: border 0.3s ease-in-out;
        margin-left: 30px;

        @media screen and (max-width: 767px) {
          flex-basis: auto;
          margin: 24px 0 0;
        }

        &:first-child {
          margin-left: 0;
        }

        &:hover,
        &:focus {
          border: 1px solid #DC281E;
        }


        &__arrow {
          position: absolute;
          display: block;
          top: 18px;
          right: 18px;
          width: 11px;
          height: 11px;

          background: {
            size: contain;
            repeat: no-repeat;
          }

          ;
          z-index: 2;

          path {
            transition: fill 0.3s ease-in-out;
          }

          .offices-map__info__banners__banner:hover &,
          .offices-map__info__banners__banner:focus & {
            path {
              fill: #DC281E;
            }
          }
        }

        &__inner {
          color: white;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 0;
          position: relative;
          z-index: 2;
          transition: color 0.3s ease-in-out;

          .offices-map__info__banners__banner:hover &,
          .offices-map__info__banners__banner:focus & {
            color: #DC281E;
          }
        }

        &__overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 1);
          opacity: 0;
          z-index: 1;
          transition: opacity 0.3s ease-in-out;

          .offices-map__info__banners__banner:hover &,
          .offices-map__info__banners__banner:focus & {
            opacity: 1;
          }
        }
      }
    }

    &__form-toggles {
      a {
        display: inline-block;
        padding-bottom: 1px;
        margin-right: 24px;
        border-bottom: 2px solid white;

        &.active {
          border-color: #dc281e;
        }
      }
    }

    &__form {
      iframe {
        width: 100%;
        height: 1550px;
        overflow: hidden;

        &.hidden {
          height: 0;
        }
      }
    }
  }

  &__header {
    &__inner {
      position: absolute;
      z-index: 2;
      top: -51px;
    }

    .container {
      @media screen and (max-width: 767px) {
        padding: 0;
      }
    }

    &__instructions {
      background: black;
      flex-basis: 316px;
      width: 316px;
      flex-grow: 0;
      height: 51px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &__reset {
      margin-top: 24px;

      a {

        &:hover,
        &:focus {
          background-color: white;

          &:after,
          &:before {
            background-color: white;
          }

          &:after,
          &:before {
            transform: rotate(180deg);
          }
        }
      }

      @media screen and (max-width: 767px) {
        position: absolute;
        top: 45px;
        left: 15px;
        z-index: 1;

        .btn {
          width: 110px;
        }
      }
    }

    p {
      color: white;
      margin: 0;
    }
  }
}

.v-collapse-content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  padding: 0;
}

.v-collapse-content-end {
  transition: max-height 0.3s ease-in;
  max-height: 800px;
}

.offices-map__media-relations {
  cursor: pointer;

  .offices-map__media-relations__inner {
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-between;
    // align-items: center;
    margin: 0 0 32px 24px;
    max-width: 350px;
    padding: 70px 0 32px 24px;
    background: linear-gradient(90deg, #DC281E 0%, #DC281E 70%, #F65F91 100%);
    transition: border 0.3s ease-in-out, background 0.3s ease-in-out, background-color 0.3s ease-in-out;
    z-index: 2;

    .white-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      opacity: 0;
      z-index: 1;
      transition: opacity 0.3s ease-in-out;
      border: 1px solid #DC281E;
    }

    .offices-map__info__banner__inner__arrow {
      position: absolute;
      top: 15px;
      right: 20px;
      width: 15px;
      height: 15px;
      transition: fill 0.3s ease-in-out;
      z-index: 2;

    }

    @media screen and (max-width: 767px) {
      display: block;
    }

    .offices-map__info__banner__inner__text {
      z-index: 3;
      h3 {
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
        transition: color 0.3s ease-in-out;
        z-index: 2;

      }

      p {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
        transition: color 0.3s ease-in-out;
        z-index: 2;
      }
    }

    // on hover reverse the arrow color to red and the text to red and border to red and background to white
    &:hover {
      .white-background {
        opacity: 1;
      }

      background-color: white;
      background: linear-gradient(90deg, #fff 0%, #fff 70%, #fff 100%);
      border: 1px solid #DC281E;

      h3 {
        color: #DC281E;
      }

      p {
        color: #DC281E;
      }

      .offices-map__info__banner__inner__arrow {
        path {
          fill: #DC281E;
        }
      }
    }


  }


}
</style>
